var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divNav"},[_c('span',{staticClass:"spanSubject",on:{"click":() => {_vm.$router.push('/')}}},[_vm._v("首页 / ")]),_c('span',{staticClass:"spanSubject",on:{"click":_vm.navClick}},[_vm._v(_vm._s(_vm.subject))]),_c('span',{staticClass:"spanSplit"},[_vm._v(" / ")]),_c('span',{staticClass:"spanName"},[_vm._v(_vm._s(_vm.project))])])
}
var staticRenderFns = []

export { render, staticRenderFns }